export default __webpack_public_path__ + "static/media/chair-360.540b74e7.png";